import React, { memo, useCallback } from 'react';
import classnames from 'classnames';

import { Modal, SearchBar } from '@Sage/hoi-poi-ui';
import AbsoluteLoader from 'components/AbsoluteLoader';

import { RatesAddItemsError } from './RatesAddItemsFeedback';
import './rates-add-items.scss';

const RatesAddItemsModal = memo(
    ({
        children,
        error,
        isOpen,
        loading,
        onClose,
        onSearch,
        onSearchInputChange,
        placeholder,
        searchValue = '',
        title,
    }) => {
        const handleSearchChange = useCallback(
            (event, context) => {
                const value = event?.target?.value ?? '';
                onSearchInputChange?.(value);
                if (context?.action === 'clear') {
                    onSearch?.('');
                }
            },
            [onSearch, onSearchInputChange],
        );

        const handleSearchBlur = useCallback(
            (event) => {
                onSearch?.(event?.target?.value ?? '');
            },
            [onSearch],
        );

        return (
            <Modal
                className="rates-add-items-modal"
                isOpen={isOpen}
                onRequestClose={onClose}
                size="medium"
                title={title}
                useContentStaticHeight
            >
                <div className="rates-add-items-modal__search">
                    <SearchBar
                        inputValue={searchValue}
                        onBlur={handleSearchBlur}
                        onChange={handleSearchChange}
                        placeholder={placeholder}
                        useAsSimpleSearch
                    />
                </div>
                <div
                    className={classnames('rates-add-items-modal__body', {
                        'rates-add-items-modal__body--centered': loading || error,
                    })}
                >
                    {loading ? <AbsoluteLoader size="massive" /> : null}
                    {!loading && error ? <RatesAddItemsError /> : null}
                    {!loading && !error ? children : null}
                </div>
            </Modal>
        );
    },
);

RatesAddItemsModal.displayName = 'RatesAddItemsModal';

export default RatesAddItemsModal;
